import PropType from 'prop-types';

const propTypes = {
    /**
     * Processes tokens and regular non-token portions of the string.
     * Returns a React element (PropType.node).
     *
     * Will be invoked like this:
     *  processChunk({ isToken: true, tokenIndex: 1, chunk: undefined }) // token
     *  processChunk({ isToken: false, tokenIndex: undefined, chunk: 'part of string' }) // non-token
     */
    processChunk: PropType.func.isRequired,

    /**
     * Message template that contains tokens.
     * Example: "Hello {0}, good {1}"
     */
    template: PropType.string,
};

/**
 * A React component that replaces i18n tokens with elements within a message string.
 * Allows customize each portion of the template string, tokens, and non-tokens.
 */
const LocalizedMessageDynamic = ({ template, processChunk }) => {
    if (!template) {
        return null;
    }

    const msgs = template.split(/({\d})/);
    const fragments = msgs.map((current) => {
        const regexMatch = /{(\d)}/.exec(current);
        const isToken = !!regexMatch;
        if (isToken) {
            const tokenIndex = parseInt(regexMatch[1], 10);
            return processChunk({ isToken: true, tokenIndex });
        }
        return processChunk({ isToken: false, chunk: current });
    });

    const truthyFragments = fragments.filter(Boolean);
    return <>{truthyFragments}</>;
};

LocalizedMessageDynamic.propTypes = propTypes;

export default LocalizedMessageDynamic;
